/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */
import { Component, ChangeDetectionStrategy } from '@angular/core'

import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'myprofile-signup-ui-maintenance',
  imports: [PorscheDesignSystemModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent {}
